module.exports = __webpack_public_path__ + "img/xqs.d881a84.png";